import { Card, CardBody, Col } from "reactstrap";
import { Badges, H6, Image, LI, UL } from "../../../../../AbstractElements";
import { ProductDeliveryTitle } from "../../../../../Constants/Constants";
import { ProductDeliveryData } from "../../../../../Data/General/Dashboard/ECommerce";
import { dynamicImage } from "../../../../../Utils";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";

const ProductDelivery = () => {
  return (
    <Col xl="3" sm="6">
      <Card className="height-equal title-line delivery-card">
        <DashboardCommonHeader title={ProductDeliveryTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="delivery-content">
          <UL className="order-list mb-0 custom-scrollbar">
            {ProductDeliveryData.map((item, index) => (
              <LI key={index}>
                <div className="light-card">
                  <Image className="img-fluid" src={dynamicImage(item.image)} alt="T-shirt" />
                </div>
                <div className="order-content">
                  <div>
                    <H6 className="mb-1">{item.title}</H6>
                    <span className="f-light f-w-500 f-12">{item.text}</span>
                  </div>
                  <div className="text-end">
                    <Badges color="transparent" className={`badge-light-${item.color} f-12`}>
                      {item.badge}
                    </Badges>
                  </div>
                </div>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ProductDelivery;
